import { Routes } from '@angular/router';
import { declarationGuard } from './_shared/guards/declaration.guard';

export const routes: Routes = [
  {
    path: 'affiliations',
    loadChildren: () => import('./accueil/routes').then(r => r.ACCUEIL_ROUTES),
  },
  {
    path: 'declaration',
    canActivate: [declarationGuard],
    loadChildren: () => import('./declaration/routes').then(r => r.DECLARATION_ROUTES),
  },
  {
    path: 'retour',
    loadChildren: () => import('./retour-nc/routes').then(r => r.RETOUR_NC_ROUTES),
  },
  {
    path: 'documents/retour',
    loadChildren: () => import('./retour-nc/routes').then(r => r.RETOUR_NC_ROUTES),
  },
  {
    path: 'habilitations/retour',
    loadChildren: () => import('./retour-nc/routes').then(r => r.RETOUR_NC_ROUTES),
  },
  {
    path: 'habilitations',
    loadChildren: () => import('./habilitations/routes').then(r => r.HABILITATION_ROUTES),
  },
  {
    path: 'documents',
    loadChildren: () =>
      import('./documents/documents-routes').then(r => r.DOCUMENTS_ROUTES),
  },
  { path: '**', redirectTo: '/habilitations' },
];
